import { useEffect } from "react";
//@ts-ignore
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";

import styles from "./styles.module.scss";

interface ExtendedGlobalI extends Window {
  closeIframe: () => void;
}

const PickerSuccessLogic = () => {
  useEffect(() => {
    handleClose();
  }, []);

  const handleClose = () => {
    (window?.parent as ExtendedGlobalI)?.closeIframe();
  };

  return (
    <div className={styles.pickerSuccessWrapper}>
      <LoadingImageElement />
    </div>
  );
};

export default PickerSuccessLogic;
